import common from './common/_index';

addEventListener('DOMContentLoaded', (): void => {
  // 全ページ共通で行う処理を実行
  common();
});
